/*
  CRYOTEIN product page (mobile optimisation Task 3). Loaded with defer on product templates from layout/theme.liquid,
  after Dawn's constants.js and pubsub.js.
  1. Back-in-stock form (decision 2): the restock form (snippets/cryo-restock-form.liquid, Klaviyo foundations Task 4)
     shows only while the selected variant is sold out.
  2. Sticky add-to-cart bar (H2 on phones; PDP CRO batch Task 5 on desktop): mirrors the page and clicks the real Add
     to cart button. Not on landscape phones (750px or wider but under 500px tall), and hidden while the selected size
     is sold out or unavailable (PDP batch final fix: no dead "Sold out" button).
  Size changes from Dawn's quick-add pop-up (cross-sell "Choose options") carry this section's id too; they are told
  apart by the main form's variant id and ignored (PDP batch final fix I1).
  No prices live here: the bar copies the text of the page's own rendered price element.
*/
(function () {
  var info = document.querySelector('product-info[id^="MainProduct-"]');
  if (!info) return;
  var sectionId = info.dataset.section;

  function selectedVariant() {
    var node = info.querySelector('variant-selects [data-selected-variant]');
    if (!node) return undefined; // unknown: leave the server-rendered state alone
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return undefined;
    }
  }

  // The variant id in the main product form. Dawn writes it before it publishes variantChange for this page.
  function formVariantId() {
    var form = document.getElementById('product-form-' + sectionId);
    var input = form && form.querySelector('input[name="id"]');
    return input ? String(input.value) : '';
  }

  /* ---------- 1. back-in-stock form ---------- */
  function setRestock(variant) {
    if (variant === undefined) return;
    var hide = !!(variant && variant.available);
    info.querySelectorAll('[data-cryo-restock]').forEach(function (marker) {
      marker.classList.toggle('cryo-restock--hidden', hide);
    });
    // The form itself (snippets/cryo-restock-form.liquid; cryo-restock.js resets it for the new size).
    info.querySelectorAll('[data-cryo-restock-form]').forEach(function (form) {
      form.classList.toggle('cryo-restock--hidden', hide);
      form.dispatchEvent(new CustomEvent('cryo:restock-variant', { detail: { id: variant ? variant.id : null } }));
    });
    // Sold out: the restock form takes the dead button area, so the dynamic checkout hides too (cryo-product.css).
    info.classList.toggle('cryo-variant-sold-out', !hide);
  }

  /* ---------- 2. sticky add-to-cart ---------- */
  var bar = document.querySelector('[data-cryo-sticky]');
  var sync = function () {};
  if (bar) sync = initSticky(bar);

  function initSticky(bar) {
    // Move to <body>: ancestors with transforms or sticky positioning would break position: fixed.
    document.body.appendChild(bar);
    bar.hidden = false;
    document.body.classList.add('cryo-has-sticky-atc');

    var formId = bar.dataset.formId;
    var stickyButton = bar.querySelector('[data-cryo-sticky-add]');
    var label = bar.querySelector('[data-cryo-sticky-label]');
    var sizeEl = bar.querySelector('[data-cryo-sticky-size]');
    var priceEl = bar.querySelector('[data-cryo-sticky-price]');
    var observed = null;
    var past = false;
    var dead = false; // the selected size can't be added (sold out or unavailable): the bar stays hidden
    // Where the bar exists (the same media conditions as cryo-product.css): phones, and desktop or tablet at least
    // 500px tall. A landscape phone (750px or wider, under 500px tall) gets no bar.
    var enabled = window.matchMedia('(max-width: 749px), (min-width: 750px) and (min-height: 500px)');
    var awaitingAdd = false; // a sticky tap is waiting for Dawn's add-to-cart response
    var restoreFocus = false; // put focus back after the cart drawer that the sticky tap opened closes

    function realButton() {
      var form = document.getElementById(formId);
      return form ? form.querySelector('button[name="add"]') : null;
    }

    // The visible, non-struck-through price item in the page's price block. Dawn swaps its contents on a size
    // change and Seal rewrites it for subscriptions, so this always matches what the page shows.
    function pagePrice() {
      var price = document.getElementById('price-' + sectionId);
      if (!price || price.classList.contains('hidden')) return '';
      var items = price.querySelectorAll('.price-item');
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (item.closest('s') || !item.getClientRects().length) continue;
        var text = item.textContent.replace(/\s+/g, ' ').trim();
        if (text) return text;
      }
      return '';
    }

    function sizeName() {
      var v = selectedVariant();
      var title = v && v.title ? String(v.title) : '';
      if (!title) {
        var checked = info.querySelector('variant-selects input[type="radio"]:checked');
        title = checked ? checked.value : '';
      }
      return /^\d+$/.test(title) ? title + '-pack' : title;
    }

    // The real button is disabled because the selected size is sold out or unavailable (not just while Dawn fetches a
    // new size: it disables the button for that too, but the selected variant still reads as available until the
    // new one arrives).
    function isDead(real) {
      if (!real || !real.disabled) return false;
      var v = selectedVariant();
      return v === undefined ? true : !(v && v.available);
    }

    function update() {
      var real = realButton();
      if (!real) return;
      // Only a real sold-out/unavailable state disables the sticky button. While an add is in flight Dawn sets
      // aria-disabled on the real button; mirroring that as `disabled` would drop keyboard and VoiceOver focus.
      var soldOut = real.disabled;
      if (stickyButton.disabled !== soldOut) stickyButton.disabled = soldOut;
      // A sold-out size hides the bar altogether (no dead "Sold out" button; the restock form is by the real button).
      if (isDead(real) !== dead) {
        dead = !dead;
        setVisible();
      }
      var busy = !soldOut && (real.getAttribute('aria-disabled') === 'true' || real.classList.contains('loading'));
      stickyButton.setAttribute('aria-disabled', busy ? 'true' : 'false');
      stickyButton.classList.toggle('cryo-sticky-atc__button--busy', busy);
      var realLabel = (real.querySelector('span') || real).textContent.replace(/\s+/g, ' ').trim();
      if (realLabel && label.textContent !== realLabel) label.textContent = realLabel;
      var size = sizeName();
      if (sizeEl.textContent !== size) sizeEl.textContent = size;
      var price = pagePrice();
      if (priceEl.textContent !== price) priceEl.textContent = price;
      if (observed !== real) watchButton(real);
    }

    function setVisible() {
      var show = past && enabled.matches && !dead;
      bar.classList.toggle('cryo-sticky-atc--visible', show);
      // On desktop the Klaviyo teaser moves up above the bar while it shows (cryo-product.css).
      document.body.classList.toggle('cryo-sticky-atc-shown', show);
      bar.inert = !show;
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    var io = null;
    var mo = new MutationObserver(update);
    function watchButton(real) {
      observed = real;
      mo.disconnect();
      mo.observe(real, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'], childList: true, subtree: true, characterData: true });
      var price = document.getElementById('price-' + sectionId);
      if (price) mo.observe(price, { attributes: true, childList: true, subtree: true, characterData: true });
      if (io) io.disconnect();
      io = new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        // show only once the visitor has scrolled past the real button, not before reaching it
        past = !e.isIntersecting && e.boundingClientRect.bottom <= 0;
        setVisible();
      });
      io.observe(real);
      watchError(real);
    }

    // An IntersectionObserver only reports threshold crossings, so a jump from below the button to above it
    // (a fast fling, an anchor link, a restored scroll position) is never reported. Re-check on scroll as well.
    var ticking = false;
    function checkPosition() {
      ticking = false;
      if (!observed) return;
      var r = observed.getBoundingClientRect();
      var nowPast = r.height > 0 && r.bottom <= 0;
      if (nowPast !== past) {
        past = nowPast;
        setVisible();
      }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(checkPosition);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // Rotating between landscape (no bar) and portrait does not change `past`, so re-apply visibility here.
    var onBreakpoint = function () {
      checkPosition();
      setVisible();
    };
    if (enabled.addEventListener) enabled.addEventListener('change', onBreakpoint);
    else if (enabled.addListener) enabled.addListener(onBreakpoint);

    // A failed add (for example a 422 stock limit) puts Dawn's error message next to the real button, which is
    // off screen while the sticky bar shows. Bring the message into view and move focus to it.
    function showAddError() {
      if (!awaitingAdd) return;
      var real = realButton();
      var productForm = real && real.closest('product-form');
      var wrapper = productForm && productForm.querySelector('.product-form__error-message-wrapper');
      var hasMessage = !!(wrapper && !wrapper.hidden);
      if (!hasMessage) return; // cartError fires before Dawn writes the message; the wrapper observer calls again
      awaitingAdd = false;
      restoreFocus = false;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      wrapper.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      if (!wrapper.hasAttribute('tabindex')) wrapper.setAttribute('tabindex', '-1');
      wrapper.focus({ preventScroll: true });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartError, function (event) {
        if (event && event.source && event.source !== 'product-form') return;
        window.setTimeout(showAddError, 0);
      });
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        awaitingAdd = false;
      });
    }
    var errorWatch = new MutationObserver(function () {
      window.setTimeout(showAddError, 0);
    });
    function watchError(real) {
      var productForm = real.closest('product-form');
      var wrapper = productForm && productForm.querySelector('.product-form__error-message-wrapper');
      errorWatch.disconnect();
      if (wrapper) {
        errorWatch.observe(wrapper, { attributes: true, attributeFilter: ['hidden'], childList: true, subtree: true, characterData: true });
      }
    }

    // Dawn's drawer returns focus to the element that opened it, but on close the sticky button is still hidden
    // (the body lock class goes last), so that focus call fails and lands on <body>. Put it back once visible.
    // Focus counts as lost when it is on <body> or still inside the closed drawer (the browser moves it out later).
    function refocus() {
      var active = document.activeElement;
      var lost = !active || active === document.body || active === document.documentElement || (drawer && drawer.contains(active));
      if (!lost) return;
      if (bar.classList.contains('cryo-sticky-atc--visible') && window.getComputedStyle(bar).display !== 'none') {
        stickyButton.focus();
      } else {
        var real = realButton();
        if (real) real.focus();
      }
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var drawerOpen = drawer.classList.contains('active');
      new MutationObserver(function () {
        var open = drawer.classList.contains('active');
        if (open && !drawerOpen) awaitingAdd = false;
        if (!open && drawerOpen && restoreFocus) {
          restoreFocus = false;
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(refocus);
          });
          window.setTimeout(refocus, 400); // again once the drawer's close transition has finished
        }
        drawerOpen = open;
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    stickyButton.addEventListener('click', function () {
      var real = realButton();
      if (!real || real.disabled || real.getAttribute('aria-disabled') === 'true') return;
      awaitingAdd = true;
      restoreFocus = true;
      real.click(); // Dawn's product-form submits the form, with Seal's selling_plan input, and opens the cart drawer
    });

    setVisible();
    update();
    return update;
  }

  /* ---------- wiring ---------- */
  function onVariantChange(variant) {
    setRestock(variant);
    sync();
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var d = event && event.data;
      if (d && d.sectionId && d.sectionId !== sectionId) return;
      // Dawn's quick-add pop-up (the cross-sell's "Choose options") publishes its own size changes with this page's
      // section id (data-original-section), but it writes the pop-up's form, not this one. Only a change that the
      // main form carries is ours.
      if (!d || !d.variant || String(d.variant.id) !== formVariantId()) return;
      onVariantChange(d.variant);
    });
  }
  // Fallback, and the path Dawn takes when a size has no variant: it updates the form's id input and fires change.
  document.addEventListener('change', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    if (t.matches('input[name="id"]') && t.form && t.form.id === 'product-form-' + sectionId) {
      onVariantChange(t.value ? selectedVariant() : null);
    } else if (info.contains(t) && t.closest('.sealsubs-target-element')) {
      window.setTimeout(sync, 0); // Seal rewrites the price after its own change handler
    }
  });

  setRestock(selectedVariant());
})();

/*
  Subscribe vs one-time tiles (PDP CRO batch Task 4). Markup and per-variant prices: snippets/cryo-plan-tiles.liquid.
  A progressive enhancement on top of Seal Subscriptions. The tiles show, and Seal's own options hide
  (.cryo-plan-host--on, cryo-product.css), only while Seal's widget is found and offers every plan of the selected
  size. The tiles submit nothing: a tile clicks Seal's own radio and the frequency sets Seal's own select, so Seal's
  selling_plan input in the product form is what the cart gets (the sticky bar clicks the real button too).
  The tiles read their state back from that input, so a change Seal makes by itself is mirrored. If Seal is left on a
  plan that doesn't belong to the selected size (a stale id after a size change), the tiles drive Seal onto this
  size's plan with the same interval, once; if that doesn't take, the size counts as not bindable.
  Host states: --pending (script running, waiting for Seal: Seal's options hidden and the height reserved, so Seal's
  widget never flashes) and --on (bound: tiles shown). Binding that stays broken for GRACE ms hands back to Seal.
  Plans are matched by selling plan id, never by name. No prices live here.
*/
(function () {
  var info = document.querySelector('product-info[id^="MainProduct-"]');
  if (!info) return;
  var sectionId = info.dataset.section;
  var root = info.querySelector('[data-cryo-plan]');
  if (!root) return;
  var host = root.parentElement;
  var GRACE = 1000; // ms that binding may stay broken (Seal missing, markup changed) before Seal's widget shows
  var WAIT_FOR_SEAL = 10000; // ms after load to keep waiting for Seal's widget at all
  var on = false;

  // Failsafe first, so a later error can't leave Seal's options hidden: without a binding the pending state ends.
  host.classList.add('cryo-plan-host--pending');
  window.setTimeout(function () {
    if (!on) host.classList.remove('cryo-plan-host--pending');
  }, WAIT_FOR_SEAL);
  function giveUp() {
    host.classList.remove('cryo-plan-host--pending');
  }

  var data;
  try {
    data = JSON.parse(root.querySelector('[data-cryo-plan-data]').textContent);
  } catch (e) {
    return giveUp();
  }
  var onceInput = root.querySelector('input[value="one_time"]');
  var subInput = root.querySelector('input[value="subscribe"]');
  var oncePrice = root.querySelector('[data-cryo-plan-once-price]');
  var subPrice = root.querySelector('[data-cryo-plan-sub-price]');
  var pctEl = root.querySelector('[data-cryo-plan-pct]');
  var saveEl = root.querySelector('[data-cryo-plan-save]');
  var saveAmount = root.querySelector('[data-cryo-plan-save-amount]');
  var saveBasis = root.querySelector('[data-cryo-plan-save-basis]');
  var freqRow = root.querySelector('[data-cryo-plan-freq]');
  var select = root.querySelector('[data-cryo-plan-select]');
  if (!data || !data.variants || !onceInput || !subInput || !select || !freqRow || !saveEl) return giveUp();

  function form() {
    return document.getElementById('product-form-' + sectionId);
  }
  function seal() {
    return host.querySelector('.sealsubs-target-element');
  }
  function variantId() {
    var f = form();
    var input = f && f.querySelector('input[name="id"]');
    return input ? String(input.value) : '';
  }
  // Seal's hidden selling_plan input in the product form: a plan id, or empty for one-time.
  function planField() {
    var f = form();
    return f ? f.querySelector('input[name="selling_plan"]') : null;
  }
  function sealOnce() {
    var s = seal();
    return s ? s.querySelector('input.sls-option[value="one_time"]') : null;
  }
  // Seal's select that offers this plan as an enabled option.
  function sealSelectFor(planId) {
    var s = seal();
    if (!s || !planId) return null;
    var selects = s.querySelectorAll('select.sls-select');
    for (var i = 0; i < selects.length; i++) {
      var opts = selects[i].options;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j].value === planId && !opts[j].disabled) return selects[i];
      }
    }
    return null;
  }
  // The subscription radio of the same Seal option group as that select.
  function sealRadioFor(sel) {
    var group = sel && sel.closest('.sls-option-container');
    return group ? group.querySelector('input.sls-option[data-type="subscription"]') : null;
  }
  function variantData() {
    return data.variants[variantId()] || null;
  }
  function findPlan(v, id) {
    if (!v || !id) return null;
    for (var i = 0; i < v.plans.length; i++) if (v.plans[i].id === id) return v.plans[i];
    return null;
  }
  function label(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }
  // Every plan id of every size with its interval label, to carry the interval over a size change.
  var labelById = {};
  Object.keys(data.variants).forEach(function (id) {
    data.variants[id].plans.forEach(function (p) {
      labelById[p.id] = label(p.label);
    });
  });
  // The plan of this size with the same interval as `id` (a plan of another size), else the size's first plan.
  function samePlanFor(v, id) {
    var want = labelById[id];
    for (var i = 0; i < v.plans.length; i++) if (want && label(v.plans[i].label) === want) return v.plans[i];
    return v.plans[0];
  }
  // Seal can be driven for this size: its one-time radio, the form input and every plan of the size are there.
  function bindable(v) {
    if (!v || !v.plans || !v.plans.length || !planField() || !sealOnce()) return false;
    for (var i = 0; i < v.plans.length; i++) {
      var sel = sealSelectFor(v.plans[i].id);
      if (!sel || !sealRadioFor(sel)) return false;
    }
    return true;
  }
  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }
  function setHidden(el, value) {
    if (el && el.hidden !== value) el.hidden = value;
  }

  var brokenTimer = 0;
  var sealSeen = false;
  function setOn(value) {
    if (value && brokenTimer) {
      window.clearTimeout(brokenTimer);
      brokenTimer = 0;
    }
    if (on === value) return;
    on = value;
    setHidden(root, !value);
    host.classList.toggle('cryo-plan-host--on', value);
    if (value) host.classList.remove('cryo-plan-host--pending');
  }
  // Binding failed. Once bound, keep the tiles for GRACE ms (Seal may be mid re-render), then hand back to Seal.
  // Before the first binding, Seal's options stay hidden until GRACE ms after Seal's widget first appeared.
  function unbound() {
    if (on) {
      if (!brokenTimer) {
        brokenTimer = window.setTimeout(function () {
          brokenTimer = 0;
          if (!bindable(variantData())) {
            setOn(false);
            giveUp();
          }
        }, GRACE);
      }
      return;
    }
    if (!sealSeen && sealOnce()) {
      sealSeen = true;
      window.setTimeout(function () {
        if (!on) giveUp();
      }, GRACE);
    }
  }

  // Put Seal on this plan: click its group's radio if Seal is on one-time or another group, then set its select.
  function drive(planId) {
    var field = planField();
    var sel = sealSelectFor(planId);
    var radio = sealRadioFor(sel);
    if (!field || !sel || !radio) return;
    if (field.value === '' || !radio.checked || sealSelectFor(field.value) !== sel) radio.click();
    if (sel.value !== planId || field.value !== planId) {
      sel.value = planId;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  var optionsFor = null;
  var redriven = ''; // variant:plan already re-driven once, so a Seal that ignores it can't loop
  function render() {
    var v = variantData();
    if (!bindable(v)) return unbound();
    var current = planField().value;
    var subscribed = current !== '';
    var plan = subscribed ? findPlan(v, current) : null;
    if (subscribed && !plan) {
      // Seal is on a plan of another size: put it on this size's plan with the same interval (once per state).
      var key = variantId() + ':' + current;
      if (redriven !== key) {
        redriven = key;
        drive(samePlanFor(v, current).id);
        current = planField().value;
        plan = findPlan(v, current);
      }
      if (!plan) return unbound();
    }
    if (!plan) {
      var sel = sealSelectFor(v.plans[0].id);
      plan = findPlan(v, select.value) || findPlan(v, sel && sel.value) || v.plans[0];
    }
    if (optionsFor !== variantId()) {
      select.textContent = '';
      v.plans.forEach(function (p) {
        var o = document.createElement('option');
        o.value = p.id;
        o.textContent = label(p.label);
        select.appendChild(o);
      });
      optionsFor = variantId();
    }
    if (select.value !== plan.id) select.value = plan.id;
    setText(oncePrice, v.price);
    setText(subPrice, plan.price);
    // A plan whose saving is against four one-off 6-packs (cryo-plan-tiles.liquid) shows that basis and no N% in
    // the name, so the tile states one basis. A no-break space keeps "save N%" together when the tile name wraps.
    setText(pctEl, !plan.vs_six && plan.pct !== null && plan.pct !== undefined ? '\u00a0' + plan.pct + '%' : '');
    if (plan.saving) setText(saveAmount, plan.saving);
    setHidden(saveBasis, !plan.vs_six);
    setHidden(saveEl, !plan.saving);
    if (onceInput.checked !== !subscribed) onceInput.checked = !subscribed;
    if (subInput.checked !== subscribed) subInput.checked = subscribed;
    setHidden(freqRow, !subscribed);
    if (root.classList.contains('cryo-plan--subscribe') !== subscribed) root.classList.toggle('cryo-plan--subscribe', subscribed);
    setOn(true);
  }
  // Seal writes its input after its own handlers; read back now and once more after they have run.
  function settle() {
    render();
    window.setTimeout(render, 0);
    window.setTimeout(render, 200);
  }

  function chooseOnce() {
    var field = planField();
    var radio = sealOnce();
    if (radio && field && field.value !== '') radio.click();
    settle();
  }
  function chooseSubscribe(planId) {
    var v = variantData();
    if (!v) return settle();
    var field = planField();
    var plan = findPlan(v, planId) || (field && findPlan(v, field.value)) || v.plans[0];
    drive(plan.id);
    settle();
  }

  onceInput.addEventListener('change', function () {
    if (onceInput.checked) chooseOnce();
  });
  subInput.addEventListener('change', function () {
    if (subInput.checked) chooseSubscribe(select.value);
  });
  select.addEventListener('change', function () {
    chooseSubscribe(select.value);
  });

  // Seal renders late and re-renders on size changes: follow the whole host (Seal may replace its target element).
  // Records caused by the tiles themselves are ignored. render() is synchronous here, so the tiles replace Seal's
  // options in the frame Seal first paints them.
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      if (!root.contains(records[i].target)) return render();
    }
  }).observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-checked', 'disabled', 'hidden'] });
  // Seal appends its selling_plan input to the form; a value written as an attribute is caught here too.
  var f = form();
  if (f) new MutationObserver(render).observe(f, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
  document.addEventListener('change', function (event) {
    var t = event.target;
    if (!t || !t.closest || root.contains(t)) return;
    if ((host.contains(t) && t.closest('.sealsubs-target-element')) || (t.matches('input[name="id"]') && t.form === form())) settle();
  });
  // Last check before an add (the real button, which the sticky bar also clicks): a value Seal wrote silently, or a
  // plan of another size, is put right before Dawn reads the form.
  document.addEventListener(
    'click',
    function (event) {
      var t = event.target;
      var button = t && t.closest ? t.closest('button[name="add"]') : null;
      if (button && button.form === form()) render();
    },
    true
  );
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var d = event && event.data;
      if (d && d.sectionId && d.sectionId !== sectionId) return;
      // Ignore the quick-add pop-up's size changes (same section id, its own form): see the buy box wiring above.
      if (d && d.variant && String(d.variant.id) !== variantId()) return;
      settle();
    });
  }
  render();
})();

/* Comparison chart scroll cue (M5, layout only): drop the edge fade once the last column is in view. */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.comparison-chart .row-wapper').forEach(function (el) {
    var chart = el.closest('.comparison-chart');
    var swiper = el.swiper;
    if (!chart || !swiper || typeof swiper.on !== 'function') return;
    var update = function () {
      chart.classList.toggle('cryo-compare--end', !!swiper.isEnd);
    };
    swiper.on('progress', update);
    swiper.on('resize', update);
    update();
  });
});
